import {request,newVue, requestMsg} from "./request";
export {newVue}
export function saveOrUpdatePmConfiguration(configuration) {
    return requestMsg({
        url: '/configuration/saveOrUpdatePmConfiguration ',
        data: JSON.stringify(configuration),
        method: "POST",
        headers : {"Content-Type" : "application/json;charset=utf-8"},
    })
}

export function queryPmConfiguration(code) {
    return request({
        url: '/configuration/queryPmConfiguration',
        params: {
            code:code
        }
    })
}
